// v-twin-src="originalUrl": sets the <img> src to the resized twin of an event
// image and swaps back to the original on a load error. One attribute per <img>,
// so no page can request a twin without the fallback. Registered globally through
// src/plugins/globalDirectives.js as 'twin-src'.
import { twinUrl } from '../util/imageUrl.js'

function onError(event) {
  const el = event.target
  const original = el.dataset.twinOriginal
  if (!original || el.src === original) return
  el.src = original
}

function apply(el, value) {
  const original = typeof value === 'string' ? value : ''
  el.dataset.twinOriginal = original
  const next = original ? twinUrl(original) : ''
  if (el.getAttribute('src') !== next) el.setAttribute('src', next)
}

export default {
  bind(el, binding) {
    el.addEventListener('error', onError)
    apply(el, binding.value)
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) apply(el, binding.value)
  },
  unbind(el) {
    el.removeEventListener('error', onError)
  },
}
